import React, { Component, PropTypes } from 'react'
import { lang } from '../../strings'
import { trackEvent, EDIT_CONTACT_DETAILS, LOAD } from '../../utils/analytics'

export default class EditCustomerInfo extends Component {
  constructor(props) {
    super(props)
    this.state = this.makeInitialState(props)
  }

  makeInitialState(props) {
    let { customer } = props
    let { contactName, emailAddress, phoneNumber } = customer.toJS()
    return {
      contactName: contactName,
      emailAddress: emailAddress,
      phoneNumber: phoneNumber,
    }
  }

  componentDidMount() {
    trackEvent(EDIT_CONTACT_DETAILS, LOAD)
  }

  render() {
    let { onClose } = this.props
    let { contactName, emailAddress, phoneNumber } = this.state

    return (
      <div className='c-edit-customer-info mp-popup-container'>
        <div className='mp-popup-content'>
          <a href='#' className='mp-close' onClick={onClose}>
            &times;
          </a>
          <h2 className='h5 color-dark-blue'>{lang.customer.edit.title}</h2>
          <p className='no-margin'>{lang.customer.edit.intro}</p>
          <form onSubmit={this.submitForm} className='sqs-block-form'>
            <div className='form-item'>
              <label>{lang.customer.contactName}</label>
              <input
                type='text'
                maxLength='27'
                name='contactName'
                onChange={this.handleContactName}
                value={contactName}
                required
              />
            </div>
            <div className='form-item'>
              <label>{lang.customer.emailAddress}</label>
              <input
                type='text'
                maxLength='35'
                name='email'
                onChange={this.handleEmailAddress}
                value={emailAddress}
                required
              />
            </div>
            <div className='form-item'>
              <label>{lang.customer.phoneNumber}</label>
              <input
                type='text'
                maxLength='18'
                name='phoneNumber'
                onChange={this.handlePhoneNumber}
                value={phoneNumber}
              />
            </div>
            <input
              type='submit'
              className='sqs-editable-button'
              value={lang.customer.edit.button}
            />
          </form>
        </div>
      </div>
    )
  }

  isDisabled() {
    let { contactName, emailAddress, phoneNumber } = this.state
    let enabled = contactName && emailAddress && phoneNumber

    return !enabled
  }

  handleContactName = ev => {
    this.setState({ contactName: ev.target.value })
  }

  handleEmailAddress = ev => {
    this.setState({ emailAddress: ev.target.value })
  }

  handlePhoneNumber = ev => {
    this.setState({ phoneNumber: ev.target.value })
  }

  submitForm = ev => {
    ev.preventDefault()
    let {
      contactName,
      emailAddress,
      phoneNumber,
      addressLine1,
      postCode,
      area,
    } = this.state
    let data = {
      contactName: contactName,
      emailAddress: emailAddress,
      phoneNumber: phoneNumber,
      addressLine1: addressLine1,
      postCode: postCode,
      area: area,
    }
    this.props.onSubmit(data)
  }
}

EditCustomerInfo.propTypes = {
  customer: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}
